module.exports = "<ng-content>\n</ng-content>\n"